module.exports = __webpack_public_path__ + "img/seminar (18).1182f3a8.jpg";